import { useTranslation } from 'react-i18next';

import { ReactComponent as UserPlus } from 'assets/icons/UserPlus.svg';
import useMxCookies from 'modules/Authentication/hooks/useMxCookies';

import EditButton from './EditButton';
import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import AddedParticipantsList from '../InviteParticipantsStepModal/AddParticipantsField/AddedParticipantsList/AddedParticipantsList';
import useParticipantsField from '../InviteParticipantsStepModal/AddParticipantsField/useParticipantsField';
import { CreateNewRoomStepsEnum } from '../utils';

const AddedParticipantsReview = () => {
  const { t } = useTranslation();
  const { mxLoggedIn } = useMxCookies();
  const { removeParticipant } = useParticipantsField();
  const {
    roomForm: { watch },
  } = useCreateNewRoomDataContext();

  const participantsWatch = watch('participants');
  const participantsCount = participantsWatch.length + (mxLoggedIn ? 1 : 0);
  const participantsText = participantsCount
    ? `${t('participants_added', { count: participantsCount })}:`
    : t('no_participants_added');

  return (
    <div className="flex gap-5">
      <UserPlus className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5 mt-1" />
      <div className="w-full flex flex-col gap-2">
        <div className="w-full flex justify-between items-center gap-1">
          <span className="text-black text-size-sm">{participantsText}</span>
          <EditButton step={CreateNewRoomStepsEnum.INVITE_PARTICIPANTS} />
        </div>
        {!!participantsCount && <AddedParticipantsList onParticipantRemove={removeParticipant} />}
      </div>
    </div>
  );
};

export default AddedParticipantsReview;
